export default __webpack_public_path__ + "static/media/building.323b72a3.svg";